import { useEffect } from "react"
import {
  BottomNavigation as MuiBottomNavigation,
  BottomNavigationAction,
  Box,
  useTheme,
} from "@mui/material"
import { Link, useLocation } from "react-router-dom"
import qs from "qs"
import { useTranslation } from "providers/i18n"
import { useAppUI } from "providers/ui"

export const DesktopNavigation = ({
  value,
  bottomNavigations = [],
  navigations = [],
}) => {
  const location = useLocation()
  const { setSidebarState } = useAppUI()

  const { t } = useTranslation()

  const theme = useTheme()
  const styleOverrides =
    theme.components[`AppDesktopNavigation`]?.styleOverrides || {}
  const { root, menuButton, navigationWrapper } = styleOverrides

  // Close Drawer when url changed
  useEffect(() => {
    setSidebarState(false)
  }, [location.pathname, setSidebarState])

  return (
    <>
      <Box sx={root}>
        <MuiBottomNavigation
          value={value}
          showLabels
          className="AppDesktopNavigation-navigationWrapper"
          sx={navigationWrapper}
        >
          {bottomNavigations.map((nav) => {
            const isActive =
              value === `${nav.to}` ||
              value === `${nav.to}?${qs.stringify(nav.qs)}`
            const activeIcon = nav.active_icon || nav.icon
            return (
              <BottomNavigationAction
                id={nav.label}
                data-testid={nav.label}
                sx={menuButton}
                component={Link}
                key={nav.to}
                label={t([`navigation.${nav.label}`, nav.label])}
                to={`${nav.to}?${qs.stringify(nav.qs)}`}
                value={nav.value || nav.to}
                icon={isActive ? activeIcon : nav.icon}
              />
            )
          })}
        </MuiBottomNavigation>
      </Box>
    </>
  )
}
